import React, { useState } from 'react';
import { baseColors, Icon, StyledIconWrapper } from '@groupby/ui-components';
import { Divider } from '@mui/material';
import { useTheme } from 'styled-components';
import { LanguageSelectionMenu } from './language-selection.component';
import { getCodeToLanguage, Localization, LocalizedMessage, useLocalization, } from '@/localization';
import { StyledMenu, StyledMenuItem, StyledSelectedLanguageText } from './menu.styles';
import { useGoToUrl } from '@/routing/hooks/utils';
import { PageIdentifier, Routing } from '@/constants';
import { modelManagerRoute } from '@/routing';
import { AuditLogIcon, GlobeIcon } from '@/components/icons';
import { useNavigation } from '@/navigation/navigation.provider';
import { useAuthLogout } from '@/auth/hooks/authentication';
import { NavigationType } from '@/navigation/types';
import BookIcon from '@/components/icons/svg/search-for-retail/book-icon';
import { useSessionAreaName, useSessionCollectionName } from '@/platform-services/session';
import { CookieConsentModal } from '@/components/cookie-consent';
import { useCookieConsent } from '@/hooks/useCookieConsent';
export const UserOptionsMenu = ({ anchorEl, handleClose, }) => {
    const theme = useTheme();
    const goToUrl = useGoToUrl();
    const activeArea = useSessionAreaName();
    const activeCollectionName = useSessionCollectionName();
    const { setVisibleRouteSection, setNavigationType } = useNavigation();
    const { getLocale, setLocale, formatMessage: t } = useLocalization();
    const selectedLanguage = getLocale();
    const codeToLanugage = getCodeToLanguage();
    const [languageMenuAnchorEl, setLanguageMenuAnchorEl] = useState(null);
    const [isCookieModalOpen, setIsCookieModalOpen] = useState(false);
    const handleLanguageSelectionOpen = (e) => setLanguageMenuAnchorEl(e.currentTarget);
    const handleCloseLanguageSelection = () => setLanguageMenuAnchorEl(null);
    const { logout } = useAuthLogout();
    const { initialCategories, save } = useCookieConsent();
    return (<React.Fragment>
      <LanguageSelectionMenu languageMenuAnchorEl={languageMenuAnchorEl} handleClose={handleCloseLanguageSelection} selectedLanguage={selectedLanguage} selectLanguage={setLocale}/>
      <StyledMenu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} $type="user">
        <StyledMenuItem color={baseColors.white} iconHoverColor={baseColors.primaryGreen000} onClick={handleLanguageSelectionOpen} iconStart={<StyledIconWrapper $variant={undefined}>
              <GlobeIcon className="icon-left"/>
            </StyledIconWrapper>}>
          <LocalizedMessage messageKey="LANGUAGE_SELECTION" values={{
            language: codeToLanugage[selectedLanguage]
                ? codeToLanugage[selectedLanguage]
                : codeToLanugage[Localization.DEFAULT_LANGUAGE_CODE],
            lang: (chunks) => (<StyledSelectedLanguageText>{chunks}</StyledSelectedLanguageText>),
            label: (chunks) => (<div>{chunks}</div>),
        }}/>
        </StyledMenuItem>

        <Divider variant="middle"/>
        <StyledMenuItem copy={t({ key: 'AUDIT_LOG' })} color={baseColors.primaryBlueMed500} onClick={() => {
            goToUrl(modelManagerRoute(PageIdentifier.AUDIT_LOG, activeCollectionName, activeArea));
            setVisibleRouteSection();
            setNavigationType(NavigationType.PRIMARY);
        }} iconStart={<StyledIconWrapper $variant={undefined}>
              <AuditLogIcon className="icon-left"/>
            </StyledIconWrapper>}/>
        <StyledMenuItem copy={t({ key: 'RELEASE_NOTES' })} color={baseColors.primaryBlueMed500} onClick={() => {
            goToUrl(Routing.ROUTE_PATHS[PageIdentifier.RELEASE_NOTES]);
            setVisibleRouteSection();
            setNavigationType(NavigationType.PRIMARY);
        }} iconStart={<StyledIconWrapper $variant={undefined}>
              <BookIcon className="icon-left"/>
            </StyledIconWrapper>}/>
        <Divider variant="middle"/>
        <StyledMenuItem copy={t({ key: 'COOKIE_CONSENT_MANAGE_COOKIES' })} color={baseColors.primaryBlueMed500} onClick={() => {
            setIsCookieModalOpen(true);
            handleClose === null || handleClose === void 0 ? void 0 : handleClose();
        }} iconStart={<StyledIconWrapper $variant={undefined}>
              <Icon variant="gear" additionalClasses="icon-left"/>
            </StyledIconWrapper>}/>
        <Divider variant="middle"/>
        <StyledMenuItem className="sign-out" copy={t({ key: 'NAVIGATION_LOG_OUT' })} color={theme.palette.error.dark} onClick={logout} iconStart={<Icon variant="rightArrowSquareBracket" additionalClasses="icon-left"/>}/>
      </StyledMenu>

      {isCookieModalOpen && (<CookieConsentModal onSave={save} onClose={() => setIsCookieModalOpen(false)} initialCategories={initialCategories}/>)}
    </React.Fragment>);
};
export default UserOptionsMenu;
